export default __webpack_public_path__ + "static/media/budget-home.4f699ef2.png";